import React, {useState} from 'react';
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {Alert, Button, Form} from 'react-bootstrap';

import AuthService from "../../services/auth.service";
import {withRouter} from '../../common/with-router';

import pfLogo from '../../img/social-logo.png';
import '../../Auth.css';


const Login = () => {
    const [searchParams, setSearchParams] = useSearchParams();  // eslint-disable-line no-unused-vars
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

    const validateForm = () => {
        const newErrors = {};
        if (!email) {
            newErrors.email = 'Email is required';
        }
        else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Email is invalid';
        }

        if (!password) {
            newErrors.password = 'Password is required';
        }
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            AuthService.login(email, password).then(
                () => {
                    navigate("/profile");
                    window.location.reload();
                },
                error => {
                    const newErrors = {};
                    newErrors.authentication = error.response.data.error
                    setErrors(newErrors);
                }
            )
        }
    };

    const showResetPass = searchParams.get("resetPass") === "true";

    return (
        <div className="auth-wrapper">
            <div className="auth-form-container">
                <h2 className="auth-title">
                    <img src={pfLogo}
                         alt="Winchester Porchfest"
                         title="Winchester Porchfest"
                         height="80px"
                         className="profile-img-card"/>
                </h2>
                {showResetPass &&
                    <Alert variant="primary">Your password has been reset successfully. You can use it to login below.</Alert>
                }
                <Form.Group>
                    <Form onSubmit={handleSubmit} className="auth-form">
                        <Form.Group className="mb-3">
                            <Form.Label>Email address:</Form.Label>
                            <Form.Control
                                type="email"
                                // placeholder="Enter email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.email}
                            </Form.Control.Feedback>
                        </Form.Group>


                        <Form.Group className="mb-3">
                            <Form.Label>Password:</Form.Label>
                            <Form.Control
                                type="password"
                                // placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                isInvalid={!!errors.password}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.password}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className="forgot-password">
                            <Link to="/forgotpass" reloadDocument="true">Forgot password?</Link>
                        </div>

                        <Button variant="primary" type="submit" className="auth-button">
                            Login
                        </Button>

                        {errors && errors.authentication &&
                            <div>
                                <br/>
                                <Alert variant="danger">{errors.authentication}</Alert>
                            </div>
                        }
                        <div className="auth-alt">
                            Not a member?&nbsp;<Link to={"/register"} reloadDocument="true">Register</Link>
                        </div>
                    </Form>
                </Form.Group>
            </div>
        </div>
    );
}

export default withRouter(Login);